// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string(),
  playerId: __t.string().name("player_id"),
  worldId: __t.string().name("world_id"),
  persistentArmyId: __t.string().name("persistent_army_id"),
  name: __t.string(),
  x: __t.f64(),
  y: __t.f64(),
  destinationX: __t.option(__t.f64()).name("destination_x"),
  destinationY: __t.option(__t.f64()).name("destination_y"),
  status: __t.string(),
  currentCityId: __t.option(__t.string()).name("current_city_id"),
  activeBattleId: __t.option(__t.string()).name("active_battle_id"),
  speedPerSecond: __t.f64().name("speed_per_second"),
  updatedAt: __t.timestamp().name("updated_at"),
});
